document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.text-keypoints-cta-block')

    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.2,
    }

    const animateNumber = (el) => {
        const originalText = el.textContent

        // 🔎 extrait le premier nombre (entier ou décimal)
        const match = originalText.match(/[\d.,]+/)
        if (!match) return

        const numberString = match[0]
        const target = parseFloat(numberString.replace(',', '.'))

        if (isNaN(target)) return

        let current = 0
        const increment = target / 20

        const interval = setInterval(() => {
            current += increment

            if (current >= target) {
                current = target
                clearInterval(interval)
            }

            // remplace uniquement la partie numérique dans le texte
            const formatted = Math.floor(current)
            el.textContent = originalText.replace(numberString, formatted)
        }, 50)
    }

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible')

                // 🎯 cible tous les .js-number dans le block visible
                const numbers = entry.target.querySelectorAll('.js-number')
                numbers.forEach((num) => animateNumber(num))

                observer.unobserve(entry.target)
            }
        })
    }, observerOptions)

    blocks.forEach((block) => observer.observe(block))
})